import { Component, Input, OnInit } from '@angular/core';
import { FilterGroup, FilterItem } from '../../model/filter.model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PageService } from 'app/services/page-service';

@Component({
  selector: 'app-filter-menu',
  templateUrl: './filter-menu.component.html',
  styles: [
  ],
})
export class FilterMenuComponent implements OnInit {
  @Input() content: any;
  @Input() filterGroups: FilterGroup[] = [];
  @Input() favoriteFilters: FilterItem[] = [];
  @Input() filterValues: any = {};

  searchText: string = '';
  autoCollapse: boolean = true;
  openedGroups: string[] = [];
  autoSearchInput: { [key: string]: string } = {};
  autoOptions: { [key: string]: any[] } = {};

  constructor(public activeModal: NgbActiveModal , 
              public service: PageService,) {}
  // ngOnInit(): void {
  //  // restore autoSearch input labels
  // Object.keys(this.filterValues || {}).forEach(key => {
  //   const val = this.filterValues[key];

  //   if (val && val.label) {
  //     this.autoSearchInput[key] = val.label;
  //   }
  // });
  // }
  ngOnInit(): void {

  // Open all filter groups by default
  this.openedGroups = this.filterGroups.map(group => group.key);

  Object.keys(this.filterValues || {}).forEach(key => {
    const val = this.filterValues[key];

    if (val && val.label) {
      this.autoSearchInput[key] = val.label;
    }
  });

}

  // ACCORDION
  toggleGroup(groupKey: string) {
    if (this.autoCollapse) {
      this.openedGroups = this.openedGroups.includes(groupKey)
        ? []
        : [groupKey];
    } else {
      if (this.openedGroups.includes(groupKey)) {
        this.openedGroups =
          this.openedGroups.filter(g => g !== groupKey);
      } else {
        this.openedGroups.push(groupKey);
      }
    }
  }

  isGroupOpen(groupKey: string): boolean {
    return this.openedGroups.includes(groupKey);
  }

  // SEARCH
  getFilteredItems(group: FilterGroup) {
    if (!this.searchText) return group.items;
    return group.items.filter(item =>
      item.label.toLowerCase()
      .includes(this.searchText.toLowerCase())
    );
  }

  // FAVORITES
  addToFavorite(item: FilterItem) {
    if (!this.favoriteFilters.find(f => f.id === item.id)) {
      this.favoriteFilters.push(item);
    }
  }

  removeFromFavorite(item: FilterItem) {
    this.favoriteFilters =
      this.favoriteFilters.filter(f => f.id !== item.id);

    delete this.filterValues[item.id];
  }

  isSelected(item: FilterItem): boolean {
    return !!this.favoriteFilters.find(f => f.id === item.id);
  }

  // SAVE
  saveFilters() {
    this.activeModal.close({
      selectedFilters: this.favoriteFilters,
      values: this.filterValues
    });
  }

  close() { 
    this.activeModal.dismiss();
  }

      // onAutoSearch(item: FilterItem, value: string) {
      //   // if (!value || value.length < 2) return;
      //   switch (item.id) {
      //     case 'sellerName':
      //       this.sellerService.getSellersByName(value)
      //         .subscribe(res => {
      //           this.autoOptions[item.id] =
      //             res.map((s: any) => ({
      //               value: s._id,
      //               label: s.sellerName
      //             }));
      //         });
      //       break;
      //     case 'category':
      //       this.categoryService.getCategoryByName(value)
      //         .subscribe(res => {
      //           this.autoOptions[item.id] =
      //             res.map((c: any) => ({
      //               value: c._id,
      //               label: c.name
      //             }));
      //         });
      //       break;
      //     case 'subCategory':
      //       this.categoryService.getSubCategoryByName(value)
      //         .subscribe(res => {
      //           this.autoOptions[item.id] =
      //             res.map((c: any) => ({
      //               value: c._id,
      //               label: c.name
      //             }));
      //         });
      //       break;
      //       case 'orderId':
      //          this.orderservice.getOrderID(value)
      //         .subscribe(res => {
      //           this.autoOptions[item.id] =
      //             res.map((c: any) => ({
      //               value: c.shortOrderID,
      //               label: c.shortOrderID
      //             }));
      //         });
      //         break;
      //         case 'userName':
      //           this.custService.getUserName(value)
      //          .subscribe(res => {
      //            this.autoOptions[item.id] =
      //              res.map((c: any) => ({
      //                value: c._id,
      //                label: c.firstName + " " + c.lastName
      //              }));
      //          });
      //           break;
      //           case 'supportId':
      //          this.supportservice.filterSupportId(value)
      //         .subscribe(res => {
      //           this.autoOptions[item.id] =
      //             res.map((c: any) => ({
      //               value: c._id,
      //               label: c.shortOrderID
      //             }));
      //         });
      //         break;
      //           case 'productName':
      //          this.productservice.getProductsName(value)
      //         .subscribe(res => {
      //           this.autoOptions[item.id] =
      //             res.map((c: any) => ({
      //               value: c._id,
      //               label: c.productName
      //             }));
      //         });
      //         break;
      //           case 'roleName':
      //          this.service.searchFilter(
      //         "aggregator/listRole",
      //         {
      //           name: value,
      //         },
      //         "data"
      //       )
      //         .subscribe(res => {
      //           this.autoOptions[item.id] =
      //             res.map((c: any) => ({
      //               value: c._id,
      //               label: c.productName
      //             }));
      //         });
      //         break;

      //              case 'glCode':
      //          this.service.searchFilter(
      //         "fpo/glHead/list",
      //         {
      //           search: value,
      //         },
      //         "data"
      //       )
      //         .subscribe(res => {
      //           this.autoOptions[item.id] =
      //             res.map((c: any) => ({
      //               value: c._id,
      //               label: c.glCode
      //             }));
      //         });
      //         break;
              
      //             case 'memberID':
      //          this.service.searchFilter(
      //         "fpo/supplier/getCompleteDTL",
      //         {
      //           search: {
      //             supplierShortID:value
      //           },
      //         },
      //         "data"
      //       )
      //         .subscribe(res => {
      //           this.autoOptions[item.id] =
      //             res.map((c: any) => ({
      //               value: c._id,
      //               label: c.supplierShortID
      //             }));
      //         });
      //         break;
      //          case 'scheme':
      //          this.service.searchFilter(
      //         "fpo/glScheme/list",
      //         {
      //             search:value
      //         },
      //         "data"
      //       )
      //         .subscribe(res => {
      //           this.autoOptions[item.id] =
      //             res.map((c: any) => ({
      //               value: c._id,
      //               label: c.schemeCode
      //             }));
      //         });
      //         break;
            
      //    }        
      //  }

      selectAutoOption(item: FilterItem, option: any) {
        this.filterValues[item.id] = {
          label: option.label,   // for display in input
          value: option.value    // actual value for API/backend
        };
        this.autoSearchInput[item.id] = option.label;
         this.autoOptions[item.id] = []; // close dropdown
         console.log(this.filterValues);
      }
}